<script lang="ts" setup>
defineProps({
  block: {
    default: false,
    type: Boolean,
  },
})
const { t } = useI18n()
const { urls } = useAppConfig()
</script>

<template>
  <span>
    <UButton
      :block="block"
      class="hidden sm:flex"
      color="gray"
      :icon="getIcon('youtube')"
      :label="t('watchOnYoutube.base')"
      size="xl"
      :to="urls.youtube"
      :ui="{ icon: { base: 'text-red-400 dark:text-red-600' } }"
      variant="subtle"
    />

    <UButton
      :block="block"
      class="sm:hidden"
      color="gray"
      :icon="getIcon('youtube')"
      :label="t('watchOnYoutube.sm')"
      size="lg"
      :to="urls.youtube"
      :ui="{ icon: { base: 'text-red-400 dark:text-red-600' } }"
      variant="subtle"
    />
  </span>
</template>

<i18n lang="json">
{
  "en": {
    "watchOnYoutube": {
      "base": "Watch our tutorials on Youtube",
      "sm": "Watch on Youtube"
    }
  },
  "es": {
    "watchOnYoutube": {
      "base": "Ver nuestros tutoriales en Youtube",
      "sm": "Ver en Youtube"
    }
  },
  "fr": {
    "watchOnYoutube": {
      "base": "Regarder nos tutoriels sur Youtube",
      "sm": "Regarder sur Youtube"
    }
  }
}
</i18n>
